import { z } from 'zod'

// common schemas
export const FILE_SYSTEM_NAME_MAX_LENGTH = 255
export const FOLDER_SYSTEM_NAME_MAX_LENGTH = 255

export const getFileBaseNameMaxLength = (extension = '') =>
	Math.max(1, FILE_SYSTEM_NAME_MAX_LENGTH - extension.length)

export const fileSystemNameSchema = z
	.string()
	.min(1, 'Min length 1 characters')
	.max(
		FILE_SYSTEM_NAME_MAX_LENGTH,
		`Max length ${FILE_SYSTEM_NAME_MAX_LENGTH} characters`,
	)
	.refine(
		(val) => !/^\s|\s$|^\.|\.$/.test(val),
		'File name cannot start or end with spaces or dots'
	)
	.refine(
		(val) => !/[\\/:*?"<>|]/.test(val),
		'File name contains invalid characters: \\ / : * ? " < > |'
	)

export const folderSystemNameSchema = z
	.string()
	.min(1, 'Folder name cannot be empty')
	.max(
		FOLDER_SYSTEM_NAME_MAX_LENGTH,
		`Folder name must be at most ${FOLDER_SYSTEM_NAME_MAX_LENGTH} characters`,
	)
	.refine(
		(val) => val.trim().length > 0,
		'Folder name cannot be only whitespace'
	)
	.refine(
		(val) => !/^\s|\s$|^\.|\.$/.test(val),
		'Folder name cannot start or end with spaces or dots'
	)
	.refine(
		(val) => !/[\\/:*?"<>|]/.test(val),
		'Folder name contains invalid characters: \\ / : * ? " < > |'
	)
	.refine((val) => {
		const reserved = [
			'CON',
			'PRN',
			'AUX',
			'NUL',
			...Array.from({ length: 9 }, (_, i) => `COM${i + 1}`),
			...Array.from({ length: 9 }, (_, i) => `LPT${i + 1}`),
		]
		return !reserved.includes(val.toUpperCase())
	}, 'Folder name is a reserved name')

// form schemas
export const folderFormSchema = z.object({
	name: folderSystemNameSchema,
})

export const createFileFormSchema = z.object({
	name: fileSystemNameSchema,
	extension: z.string().optional(),
})

export const editFileFormSchema = z.object({
	name: fileSystemNameSchema,
	extension: z.string().optional(),
})
